import { Link } from "react-router-dom";
import { useState } from "react";
import { resetPassword } from "@/server/api-services";
import { Button, Text, Input, Password } from "rizzui";
import { SubmitHandler } from "react-hook-form";
import { Form } from "@/ui/form";
import routes from "@/routers/routes";
import {
  resetPasswordSchema,
  ResetPasswordSchema,
} from "@/validators/reset-password.schema";

const initialValues = {
  email: "",
  password: "",
  confirmPassword: "",
};

export default function ResetPasswordForm() {
  const [reset, setReset] = useState({});

  const onSubmit: SubmitHandler<ResetPasswordSchema> = async (data) => {
    try {
      const response = await resetPassword(data);
      if (response.statusCode !== 200) {
        throw new Error(response.message);
      }
      setReset(initialValues);
      alert("Password reset successful. You can now sign in.");
    } catch (error: any) {
      alert(error.message || "Failed to reset password.");
    }
  };

  return (
    <>
      <Form<ResetPasswordSchema>
        validationSchema={resetPasswordSchema}
        resetValues={reset}
        onSubmit={onSubmit}
        useFormProps={{
          mode: "onChange",
          defaultValues: initialValues,
        }}
        className="pt-1.5"
      >
        {({ register, formState: { errors } }) => (
          <div className="space-y-6">
            <Input
              type="email"
              size="lg"
              label="Email"
              placeholder="Enter your email"
              className="[&>label>span]:font-medium"
              inputClassName="text-sm"
              {...register("email")}
              error={errors.email?.message as string}
            />
            <Password
              label="Password"
              placeholder="Enter your password"
              size="lg"
              className="[&>label>span]:font-medium"
              inputClassName="text-sm"
              {...register("password")}
              error={errors.password?.message as string}
            />
            <Password
              label="Confirm Password"
              placeholder="Enter confirm password"
              size="lg"
              className="[&>label>span]:font-medium"
              inputClassName="text-sm"
              {...register("confirmPassword")}
              error={errors.confirmPassword?.message as string}
            />
            <Button className="mt-2 w-full" type="submit" size="lg">
              Reset Password
            </Button>
          </div>
        )}
      </Form>
      <Text className="mt-6 text-center text-[15px] leading-loose text-gray-500 lg:mt-8 lg:text-start xl:text-base">
        Don’t want to reset your password?{" "}
        <Link
          to={routes.auth.signIn1}
          className="font-bold text-gray-700 transition-colors hover:text-blue"
        >
          Sign In
        </Link>
      </Text>
    </>
  );
}
